import React, { useEffect, useState } from "react";
import {
  IonButton,
  IonContent,
  IonFooter,
  IonIcon,
  IonItem,
  IonList,
  IonPage,
  IonPopover,
} from "@ionic/react";
import useAPI from "../../hooks/basic/useAPI";
import MatchCard from "../../components/MatchCard/MatchCard";
import ServicePhase from "./sub/ServicePhase";
import InGame from "./sub/InGame";
import useMatchSnapshot from "../../hooks/match/useMatchSnapshot";
import { ellipsisVertical } from "ionicons/icons";
import { useHistory } from "react-router";
import SelectPlayerPhase from "./sub/SelectPlayerPhase";
import ServiceResultSelection from "./sub/ServiceResultSelection";

const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 2);

const dictionary = {
  initialized: "Seleziona il giocatore che serve per primo",
  in_game: "Scambio in corso",
  first_service: "Prima di servizio",
  second_service: "Seconda di servizio",
  finished: "Finito",
  waiting: "In Attesa",
  game_over: "Terminata",
};

const MatchPage = ({ match }) => {
  const matchId = match.params.matchId;
  const { callAPI } = useAPI();
  const history = useHistory();
  const [matchData, setMatch] = useState(null);
  const [showPopover, setShowPopover] = useState(false);
  const [event, setEvent] = useState(undefined);

  const { data: rtMatch } = useMatchSnapshot(`/matches/${matchId}`);

  const loadMatch = async () => {
    try {
      const response = await callAPI({
        url: `/match`,
        params: {
          id: matchId,
        },
      });
      setMatch(response);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadMatch();
  }, []);

  const lastData = rtMatch ?? matchData;

  if (!lastData) {
    return null;
  }

  const { currentStatus } = lastData;

  const otherPlayersTeam = [];
  if (currentStatus && currentStatus.current_team) {
    otherPlayersTeam.push(...lastData[currentStatus.current_team]);
  }

  const selectServicePlayer = async (athleteId) => {
    try {
      const resultNewAction = await callAPI({
        url: `/match-action`,
        method: "POST",
        data: {
          matchId: matchData.id,
          action: "select_first_player",
          data: {
            athleteId,
          },
        },
      });
      setMatch(resultNewAction);
    } catch (error) {
      console.error(error);
    }
  };

  const selectSecondTeamServicePlayer = async (athleteId) => {
    try {
      const resultNewAction = await callAPI({
        url: `/match-action`,
        method: "POST",
        data: {
          matchId: matchData.id,
          action: "select_secondteam_startplayer",
          data: {
            athleteId,
          },
        },
      });
      setMatch(resultNewAction);
    } catch (error) {
      console.error(error);
    }
  };

  const sendAction = async (action, actionData) => {
    try {
      const resultNewAction = await callAPI({
        url: `/match-action`,
        method: "POST",
        data: {
          matchId: matchData.id,
          action,
          data: actionData,
        },
      });
      setMatch(resultNewAction);
      console.log("resultNewAction:", resultNewAction);
    } catch (error) {
      console.error(error);
    }
  };

  const undoLastAction = async () => {
    try {
      const resultNewAction = await callAPI({
        url: `/undo-last-action`,
        method: "POST",
        data: {
          matchId: matchData.id,
        },
      });
      setMatch(resultNewAction);
    } catch (error) {
      console.error(error);
    }
  };

  const isServicePhase = ["first_service", "second_service"].includes(
    currentStatus.phase,
  );

  return (
    <IonPage>
      <IonContent id="match-page">
        <div
          style={{
            display: "flex",
          }}
        >
          <IonButton
            fill="clear"
            style={{
              marginLeft: "auto",
            }}
            onClick={(e) => {
              e.persist();
              setEvent(e.nativeEvent);
              setShowPopover(true);
            }}
          >
            <IonIcon icon={ellipsisVertical} />
          </IonButton>
          <IonPopover
            isOpen={showPopover}
            event={event}
            onDidDismiss={() => setShowPopover(false)}
          >
            <IonList>
              <IonItem
                button
                onClick={() => {
                  setShowPopover(false);
                  history.push(`/match/${matchId}/settings`);
                }}
              >
                Impostazioni
              </IonItem>
              <IonItem
                button
                onClick={() => {
                  setShowPopover(false);
                  history.push(`/match/${matchId}/stats`);
                }}
              >
                Statistiche
              </IonItem>
            </IonList>
          </IonPopover>
        </div>
        <MatchCard match={lastData} />

        <h2 className="ion-text-center">
          {currentStatus.phase in dictionary && dictionary[currentStatus.phase]}
        </h2>
        {currentStatus.phase === "initialized" && (
          // select player who will serve first
          <SelectPlayerPhase
            allPlayers={[...lastData.team_a, ...lastData.team_b]}
            selectServicePlayer={selectServicePlayer}
          />
        )}
        {currentStatus.phase === "other_team_player_selection" && (
          // select player who will serve first
          <SelectPlayerPhase
            allPlayers={otherPlayersTeam}
            selectServicePlayer={selectSecondTeamServicePlayer}
          />
        )}
        {isServicePhase && (
          <ServicePhase
            isSecondService={currentStatus.phase === "second_service"}
            onAction={sendAction}
            currentStatus={currentStatus}
          />
        )}
        {currentStatus.phase === "in_game" && (
          <InGame
            match={lastData}
            onAction={sendAction}
            currentStatus={currentStatus}
          />
        )}
        {currentStatus.phase === "service_result_selection_1" && (
          <ServiceResultSelection
            match={lastData}
            onAction={sendAction}
            currentStatus={currentStatus}
          />
        )}
        {currentStatus.phase === "service_result_selection_2" && (
          <ServiceResultSelection
            match={lastData}
            onAction={sendAction}
            currentStatus={currentStatus}
          />
        )}
        {/* <IonButton onClick={undoLastAction}>Undo</IonButton> */}

      </IonContent>
      <IonFooter
        className="ion-no-border ion-padding"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: ".5rem",
        }}
      >
        <IonButton
          color="danger"
          expand="block"
          size="large"
          disabled={currentStatus.phase === "initialized"}
          onClick={undoLastAction}
        >
          Annulla ultima azione
        </IonButton>
      </IonFooter>
    </IonPage>
  );
};

export default MatchPage;
